import type { TrpcRouter } from '@api/infra/trpc/router';
import { createTRPCClient } from '@trpc/client';
import { createTRPCReact, httpBatchLink } from '@trpc/react-query';
import { type inferRouterOutputs } from '@trpc/server';
import superjson from 'superjson';

import { API_ENDPOINT } from '@/env';
import { authStore } from '@/stores/auth';

export const trpc = createTRPCReact<TrpcRouter>();

export type RouterOutput = inferRouterOutputs<TrpcRouter>;

const trpcLinks = [
  httpBatchLink({
    url: `${API_ENDPOINT}/trpc`,
    headers: () => ({
      authorization: `Bearer ${authStore.getState().authToken || ''}`
    }),
    transformer: superjson
  })
];

export const trpcReactClient = trpc.createClient({
  links: trpcLinks
});

export const trpcVanillaClient = createTRPCClient<TrpcRouter>({
  links: trpcLinks
});
